import React, { useEffect, useState } from 'react'
import './customRange.css';

export const CustomRange = ({ values = [], showLegend = false, min = 1, max, value, step = 1, onChange }) => {
    const [minValue, setMinValue] = useState(value ? value.minRange : min);
    const [maxValue, setMaxValue] = useState(value ? value.maxRange : max);

    useEffect(() => {
        if (value) {
            setMinValue(value.minRange);
            setMaxValue(value.maxRange);
        }
    }, [value]);

    const handleMinChange = e => {
        e.preventDefault();
        if (Number(e.target.value) !== value.maxRange && Number(e.target.value) < value.maxRange) {
            let pos = (e.target.value) <= 0 ? 0 : e.target.value - 1;
            if (!value) setMinValue(values[pos].range);
            onChange({ minRange: values[pos].range, minNumber: values[pos].number, maxRange: maxValue, maxNumber: values[maxValue - 1].number });
        }
    };

    const handleMaxChange = e => {
        e.preventDefault();
        if (Number(e.target.value) !== value.minRange && Number(e.target.value) > value.minRange) {
            let pos = e.target.value === value.minRange ? value.minRange : e.target.value - 1;
            if (!value) setMaxValue(values[pos].range);
            onChange({ minRange: minValue, minNumber: value.minNumber, maxRange: values[pos].range, maxNumber: values[pos].number });
        }
    };

    const minPos = ((minValue - min) / (max - min)) * 100;
    const maxPos = ((maxValue - min) / (max - min)) * 100;

    return (
        <>
            <div>
                <div className='d-flex justify-content-between'>
                    {values.length && showLegend ?
                        values.map((value, i) =>
                            <p key={i} className='mb-0' style={{ color: 'var(--gray-900)' }}>{value.description}</p>
                        )
                        : null
                    }
                </div>
            </div>
            <div className="wrapper mb-1 ms-2 me-2">

                <div className="input-wrapper">
                    <input
                        className="input"
                        type="range"
                        value={minValue}
                        min={min}
                        max={max}
                        /* step={step} */
                        onChange={handleMinChange}
                    />
                    <input
                        className="input"
                        type="range"
                        value={maxValue}
                        min={min}
                        max={max}
                        /* step={step} */
                        onChange={handleMaxChange}
                    />
                </div>

                <div className="control-wrapper">
                    <div className="control" style={{ left: `${minPos}%` }} />
                    <div className="rail">
                        <div
                            className="inner-rail"
                            style={{ left: `${minPos}%`, right: `${100 - maxPos}%` }}
                        />
                    </div>
                    <div className="control" style={{ left: `${maxPos}%` }} />
                </div>
            </div>
        </>

    );
};